'use client'

import { useTranslations } from 'next-intl'
import { cn, useMediaQuery } from '@segway/core'

import { Link } from '@/i18n/navigation'
import { Button } from '@/ui'

import { Breadcrumb } from '../breadcrumb'
import { Arrow, EmptyIcon } from '../icons'

export type TEmptyDataProps = {
  emptyIcon?: React.ReactNode
  title?: string
  message?: string
  btnText?: string
  link?: string
  titleStyle?: string
  messageStyle?: string
  btnStyle?: string
  pathname?: string
  isActionBtnVisible?: boolean
  isArrowBtnVisible?: boolean
}

/**
 * 数据空展示
 */
const EmptyData = (props: TEmptyDataProps) => {
  const tCommon = useTranslations('Common')
  // TODO: 下面文案翻译
  const {
    emptyIcon,
    title,
    message = tCommon('no_more_content'),
    btnText = tCommon('go_home'),
    link,
    titleStyle = '',
    messageStyle = '',
    btnStyle = '',
    pathname,
    isActionBtnVisible = true,
    isArrowBtnVisible = true,
  } = props

  const responsive = useMediaQuery()

  return (
    <>
      {pathname && (
        <div className="hidden border-b border-gray-2 py-7 xl:block">
          <div className="max-page-content px-4 xl:px-0">
            <Breadcrumb
              items={[
                { label: 'Inicio', href: '/' },
                {
                  label: pathname.split('/')[pathname.split('/').length - 1],
                  href: `/${pathname}`,
                },
              ]}
            />
          </div>
        </div>
      )}
      <div className="flex flex-col items-center justify-center">
        {emptyIcon ? (
          emptyIcon
        ) : (
          <EmptyIcon className="h-[12rem] w-[12rem] xl:h-[18rem] xl:w-[18rem]" />
        )}
        {title && (
          <h2 className={cn('mt-3 font-miSansDemiBold450 text-2xl', titleStyle)}>{title}</h2>
        )}
        {message && (
          <p className={cn('font-miSansRegular330 text-base text-gray-4 xl:text-lg', messageStyle)}>
            {message}
          </p>
        )}
        {btnText && isActionBtnVisible && (
          <div className="mt-6 flex items-center gap-1.5 xl:mt-7">
            <Button
              variant={'secondary'}
              outline="secondary"
              className={cn(
                'h-[22px] border-none p-0 text-base text-black hover:bg-transparent xl:text-pc-xl',
                btnStyle,
              )}
              asChild>
              <Link href={link ? link : '/'}>{btnText}</Link>
            </Button>
            {isArrowBtnVisible && (
              <Arrow
                width={responsive && responsive.xl ? 20 : 16}
                height={responsive && responsive.xl ? 20 : 16}
                color="#000000"
              />
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default EmptyData
